import { Action, Dispatch } from "redux";
import fetchCategories from "app/umbraco/helpers/fetchCategories";

export const GET_CATEGORIES = "GET_CATEGORIES";

export interface GetCategoriesAction extends Action {
    type: typeof GET_CATEGORIES;
    categories: any[];
}

let categoriesCache: Promise<any> | undefined = undefined;
export const thunkGetCategories =
    (url: string) =>
    async (dispatch: Dispatch): Promise<void> => {
        try {
            if (!url) {
                throw new Error();
            }

            // Check for cached categories.
            const request = categoriesCache ? categoriesCache : fetchCategories(url);
            categoriesCache = request;

            const response = await request;

            if (response && response.statusCode === 200) {
                dispatch({
                    type: GET_CATEGORIES,
                    categories: response.result,
                });
            }
        } catch {
            console.warn("Catalog is unavailable at this time");
        }
    };

export type CatalogAction = GetCategoriesAction;
